import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles(function() {
  return {
    title: {
      fontSize: 20,
      fontFamily: 'Montserrat',
      color: '#323232'
    },
    subtitle: {
      fontSize: 16,
      fontFamily: 'Roboto Medium',
      opacity: 54,
      color: '#a0a0a0'
    },
    paper: {
      minHeight: '80px',
      margin: '26px 0',
      padding: '20px',
      backgroundColor: '#EFEEEE',
      borderRadius: 12,
      boxShadow:
        '-6px -6px 26px 0px rgba(255,255,255,.83), 6px 6px 16px 0px rgba(217,210,200,.51)'
    }
  };
});

export default props => {
  const classes = useStyles();
  const { title, subtitle, children } = props;

  return (
    <div className={classes.paper} {...props}>
      <div className={classes.title}>{title}</div>
      <div className={classes.subtitle}>{subtitle}</div>
      {children}
    </div>
  );
};
